<template>
  <div class="form-radio">
    <input type="radio" v-bind="{ id, name, disabled, required, value }" @change.stop="toggleCheck" :checked="isSelected">

    <label :for="id"></label>

    <label :for="id" v-if="hasSlot">
      <slot></slot>
    </label>
  </div>
</template>

 <script>
  import FormInputEmit from '../FormInputEmit'

  export default {
    name: 'form-radio',
    mixins: [
      FormInputEmit
    ]
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  $input-sides: 20px;

  .form-radio {
    display: flex;
    min-height: $input-sides;
    min-width: $input-sides;
  }

  input {
    opacity: 0;
    height: 0;
    width: 0;
    pointer-events: none;
    position: absolute;

    + label {
      position: relative;
      height: $input-sides;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;

      &:before {
        content: '';
        margin-right: 5px;
        outline: none;
        height: $input-sides;
        width: $input-sides;
        border-radius: 50%;
        background: none;
        display: inline-block;
        cursor: pointer;
        border: 1px solid $color-sidebar;
        box-shadow: inset 0 0 0 2px #838F92;
        will-change: border-color;
        transition: border-color .3s $transition-ease-in-out;
      }

      &:after {
        content: '';
        width: 10px;
        height: 10px;
        background: #838F92;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 5px;
        bottom: 0;
        margin: auto;
        cursor: pointer;
        opacity: 0;
        transform: scale(.7);
        will-change: opacity, transform;
        transition: opacity .3s $transition-ease-in-out, transform .3s $transition-ease-in-out;
      }
    }

    &:checked {
      & + label {
        &:after {
          opacity: 1;
          transform: scale(1);
        }
      }
    }

    &.error {
      & + label {
        &:before {
          border: 1px solid $color-red;
        }
      }
    }
  }

  label {
    display: flex;
    align-items: center;
    min-height: $input-sides;
    cursor: pointer;
  }

  .main-input {
    input {
      + label {
        position: relative;
        &:after {
          position: absolute;
          top: 0;
          left: 0;
          width: 20px;
          height: 20px;
          background: #fff;
          border: 6px solid $color-tomato-two
        }
      }
    }
  }
</style>
